/*
Purpose: Header of AP
Developer: BY P.KS
Date:22/08/2023
Project: TCMS
*/

/*
Purpose: Header of AP
Designer: R.Sanjai
Date:23/08/2023
Project: TCMS
*/

import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useLocation, useNavigate } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import IconButton from '@mui/material/IconButton';

import { Image } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

import SearchIcon from '@mui/icons-material/Search';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Notifications from './Notifications';



const Header = ({ isOpen, toggleSidebar, handleSearchChange }) => {



    ///Restrict for Login component
    const location = useLocation();
    const navigate = useNavigate();

    const [manualMenu, setManualMenu] = useState(false);
    const manualBtnRef = useRef(null);
    const manualMenuRef = useRef(null);
    const [manualMenuPos, setManualMenuPos] = useState({ top: 0, left: 0 });

    const pdfManuals = [
        {
            name: "TCMS User Manual",
            url: "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/manuals/TCMS_User_Manual_V2.pdf",
        },
        {
            name: "Initial Diagnostics User Manual",
            url: "https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/manuals/Initial Diagnostics User Manual V1-1.pdf",
        },
    ];

    useEffect(() => {
        if (manualMenu && manualBtnRef.current) {
            const rect = manualBtnRef.current.getBoundingClientRect();
            setManualMenuPos({
                top: rect.bottom + 4,
                left: rect.right - 220,
            });
        }
    }, [manualMenu]);

    useEffect(() => {
        if (!manualMenu) return;
        const handleClickOutside = (e) => {
            if (manualBtnRef.current && manualBtnRef.current.contains(e.target)) return;
            if (manualMenuRef.current && manualMenuRef.current.contains(e.target)) return;
            setManualMenu(false);
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [manualMenu]);

    // List of routes where the header should not be displayed
    const headerExcludedRoutes = ['/'];


    //default sidebar
    const url = location.pathname + location.search;

    if (headerExcludedRoutes.includes(location.pathname)) {
        return null; // Don't render the header
    }



    const handleSearchPage = () => {

        // Redirect to the login page
        navigate("/StudentSearch");

    };

    const handleSearchPage1 = (event) => {

        if (event.key == 'Enter') {
            event.preventDefault();
            handleSearchPage();
        }
        // Redirect to the login page


    };


    //const [data, setData] = useState([]); // Unconditionally call useState



    //   if (sessionStorage.getItem('key') == 0) {
    //     const new_data = [
    //       {
    //         user_name: sessionStorage.getItem('first_name') + ' ' + sessionStorage.getItem('sur_name'),
    //         account_type: "Super Admin"
    //       }
    //     ];
    //     setData(new_data);
    //   } else {
    //     const new_data = [
    //       {
    //         user_name: sessionStorage.getItem('first_name') + ' ' + sessionStorage.getItem('sur_name'),
    //         account_type: "Center Administrator"
    //       }
    //     ];
    //     setData(new_data);
    //   }
    const keychk = sessionStorage.getItem('is_admin');

    const styles = {
        popup: {
            display: keychk == '1' ? "block" : "none",

        },
        popup1: {
            display: keychk != '1' ? "block" : "none",

        }
    }

    

    const handleGoBack = () => {
        //const location = useLocation();
        
        if (['/calendar'].includes(location.pathname)) {
           
            return null; // Don't render the header
        }

        window.history.back();


    };


    return (
        <div {...(isOpen && { className: "headLMOpen" })} >
            <div id="navbar" className='d-flex align-items-center flex-grow-1 justify-content-between py-2'>
                <div className='d-flex gap-3 align-items-center'>
                    <IconButton className='cus-menu-btn my-button mt-1' variant="contained" aria-label="delete" size="large"
                        sx={{ m: 0, ...(isOpen && { display: 'none' }) }}
                        onClick={toggleSidebar} >
                        <MenuIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton sx={{ m: 0, ...(!isOpen && { display: 'none' }) }} className='cus-menu-btn my-button mt-1' onClick={toggleSidebar} edge="start" color="inherit" aria-label="menu"   >
                        <ArrowBackIosNewIcon fontSize="inherit" />
                    </IconButton>
                    {/* Added here UX perspective*/}


                    {/* { sessionStorage.getItem('is_admin') == 1 ? ( */}
                    <div className='site-identity custom-d mb-0'>
                        <Image src="mygooroo-tcms.png" width={96} className="img-fluid mx-auto d-block" />
                    </div>

                    {/* ) : (
                            <div className='site-identity'>
                            <Image src="logo.png" width={120} className="img-fluid mx-auto d-block" />
                        </div>
                        )
                    } */}
                    <Button className="secondary-filled p-0" variant="contained" onClick={() => handleGoBack()}>
                        <ChevronLeftIcon fontSize="md" />Back
                    </Button>
                </div>
                <div className='d-flex align-items-center justify-content-end gap-2'>
                    <div className='search-section'>
                        <Paper component="form"
                            sx={{ p: '5px 2px 5px 10px', display: 'flex', alignItems: 'center', width: 450, borderRadius: 3 }}>

                            <InputBase sx={{ flex: 1 }}
                                inputProps={{ 'aria-label': 'Search' }} id='global_search' onChange={handleSearchChange} onKeyDown={handleSearchPage1} placeholder='Search for a student, parent, or tutor by name, username, or email...' />
                            <IconButton type="button" sx={{ p: '0px', m: 0 }} aria-label="search" onClick={handleSearchPage} >
                                <SearchIcon />
                            </IconButton>

                        </Paper>
                    </div>
                    <div>
                        <div style={{textAlign:'center', position:'relative'}}>
                            <button
                                type="button"
                                ref={manualBtnRef}
                                onClick={() => setManualMenu(prev => !prev)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: 'black',
                                    cursor: 'pointer',
                                    padding: 0,
                                }}
                            >
                                <i className="fa-solid fa-book-open me-md-2 my-auto"></i>
                            </button>
                            {manualMenu && ReactDOM.createPortal(
                                <div
                                    ref={manualMenuRef}
                                    style={{
                                        position: 'fixed',
                                        top: manualMenuPos.top,
                                        left: manualMenuPos.left,
                                        zIndex: 1060,
                                        minWidth: '220px',
                                        background: '#fff',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
                                        padding: '4px 0',
                                    }}
                                >
                                    {pdfManuals.map((manual, idx) => (
                                        <a
                                            key={idx}
                                            href={manual.url}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            download
                                            className="dropdown-item"
                                            style={{ cursor: 'pointer', display: 'block', padding: '6px 16px', color: '#212529', textDecoration: 'none' }}
                                            onClick={() => setManualMenu(false)}
                                        >
                                            {manual.name}
                                        </a>
                                    ))}
                                </div>,
                                document.body
                            )}
                        </div>
                    </div>
                    <div className='notification'>
                        <Notifications />

                    </div>
                </div>


            </div>
        </div>
    );

}

export default Header;